/*
============================================
CLUSTER A/B TEST: Shop the Look
Test ID: de04c81f-7b9b-4102-aeb7-534ef5400764
Control Variant ID: da8f7079-e991-4387-a37c-a2903204ed18
Treatment Variant ID: 9bd9495f-184a-4640-b3d5-8b4220553e75
============================================
*/
(function() {
  var TEST_ID = 'de04c81f-7b9b-4102-aeb7-534ef5400764';
  var CONTROL_VARIANT_ID = 'da8f7079-e991-4387-a37c-a2903204ed18';
  var TREATMENT_VARIANT_ID = '9bd9495f-184a-4640-b3d5-8b4220553e75';
  var currentVariant = 'control';

  function getAssignments() {
    if (window.cluster_ctx && Array.isArray(window.cluster_ctx.assignments)) {
      return window.cluster_ctx.assignments;
    }
    if (window.__clusterDebug && Array.isArray(window.__clusterDebug.assignments)) {
      return window.__clusterDebug.assignments;
    }
    return null;
  }

  function getAssignedVariant() {
    var assignments = getAssignments();
    if (!assignments) return null;

    for (var i = 0; i < assignments.length; i++) {
      var assignment = assignments[i];
      if (!assignment || assignment.testId !== TEST_ID) continue;

      if (assignment.variantId === TREATMENT_VARIANT_ID) return 'treatment';
      if (assignment.variantId === CONTROL_VARIANT_ID) return 'control';

      if (assignment.variant && typeof assignment.variant.isControl === 'boolean') {
        return assignment.variant.isControl ? 'control' : 'treatment';
      }
    }

    return null;
  }

  function applyVariant(variant) {
    currentVariant = variant === 'treatment' ? 'treatment' : 'control';
    var isTreatment = currentVariant === 'treatment';
    document.documentElement.classList.toggle('is-shop-the-look-treatment', isTreatment);
  }

  function resolveAndApply() {
    var assignedVariant = getAssignedVariant();
    applyVariant(assignedVariant || 'control');
    return assignedVariant;
  }

  window.isShopTheLookTreatment = function() {
    return currentVariant === 'treatment';
  };

  resolveAndApply();

  var attempts = 0;
  var maxAttempts = 80;
  var pollInterval = setInterval(function() {
    attempts += 1;
    var assignedVariant = getAssignedVariant();
    if (assignedVariant) {
      applyVariant(assignedVariant);
      clearInterval(pollInterval);
      return;
    }
    if (attempts >= maxAttempts) {
      clearInterval(pollInterval);
    }
  }, 250);
})();
